import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useCartorioStore } from '@/stores/cartorio';
import { useTipoUsuario } from '@/composables/useTipoUsuario';
import authService from '@/services/auth';
import Cookies from 'js-cookie';

const adminRoutes = [].map((item) => {
  item.path = '/admin' + item.path;
  item.beforeEnter = (to, from, next) => {
    if (!useAuthStore().user?.isAdmin) next('/');
    next();
  };
  return item;
});
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      beforeEnter: async (to, from, next) => {
        const auth = useAuthStore();
        const token = auth.getToken();
        
        // Se tem token local, redireciona para home
        if (token) {
          next('/');
          return;
        }
        
        // Sem token, redireciona direto para backend iniciar login no Keycloak
        window.location.href = `${import.meta.env.VITE_API_URL}/login?redirectUrl=${window.location.href}`;
      },
    },
    {
      path: '/sem-permissao',
      name: 'sem-permissao',
      component: () => import('@/views/SemPermissaoView.vue'),
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
    },
    {
      path: '/sacar-dinheiro',
      name: 'sacar-dinheiro',
      component: () => import('@/views/SacarDinheiroView.vue'),
    },
    {
      path: '/confirmar-saque',
      name: 'confirmar-saque',
      component: () => import('@/views/ConfirmarSaqueView.vue'),
    },
    {
      path: '/saque-sucesso',
      name: 'saque-sucesso',
      component: () => import('@/views/SaqueSucessoView.vue'),
    },
    {
      path: '/sacar-dinheiro-detalhe',
      name: 'sacar-dinheiro-detalhe',
      component: () => import('@/views/SacarDinheiroDetalheView.vue'),
    },
    {
      path: '/depositar-boleto',
      name: 'depositar-boleto',
      component: () => import('@/views/DepositarBoletoView.vue'),
    },
    {
      path: '/depositar-pix',
      name: 'depositar-pix',
      component: () => import('@/views/DepositarPixView.vue'),
    },
    {
      path: '/adicionar-dinheiro',
      name: 'adicionar-dinheiro',
      component: () => import('@/views/AdicionarDinheiroView.vue'),
    },
    {
      path: '/extrato-geral',
      name: 'extrato-geral',
      component: () => import('@/views/ExtratoGeralView.vue'),
    },
    {
      path: '/dados-conta',
      name: 'dados-conta',
      component: () => import('@/views/DadosContaView.vue'),
    },
    {
      path: '/dados-conta-escolha',
      name: 'dados-conta-escolha',
      component: () => import('@/views/DadosContaEscolhaView.vue'),
    },
    {
      path: '/dados-conta-resumo',
      name: 'dados-conta-resumo',
      component: () => import('@/views/DadosContaResumoView.vue'),
    },
    {
      path: '/conta-criada-sucesso',
      name: 'conta-criada-sucesso',
      component: () => import('@/views/ContaCriadaSucessoView.vue'),
    },
    {
      path: '/dados-conta-pix',
      name: 'dados-conta-pix',
      component: () => import('@/views/DadosContaPixView.vue'),
    },
    {
      path: '/dados-conta-cnpj',
      name: 'dados-conta-cnpj',
      component: () => import('@/views/DadosContaCnpjView.vue'),
    },
    {
      path: '/dados-conta-chave-cnpj',
      name: 'dados-conta-chave-cnpj',
      component: () => import('@/views/DadosContaChaveCnpjView.vue'),
    },
    {
      path: '/entenda-sua-conta',
      name: 'entenda-sua-conta',
      component: () => import('@/views/EntendaSuaContaView.vue'),
    },
    {
      path: '/confirmar-deposito-pix',
      name: 'confirmar-deposito-pix',
      component: () => import('@/views/ConfirmarDepositoPixView.vue'),
    },
    {
      path: '/deposito-pix-qrcode',
      name: 'deposito-pix-qrcode',
      component: () => import('@/views/DepositoPixQRCodeView.vue'),
    },
    {
      path: '/confirmar-boleto',
      name: 'confirmar-boleto',
      component: () => import('@/views/ConfirmarBoletoView.vue'),
    },
    {
      path: '/boleto-gerado',
      name: 'boleto-gerado',
      component: () => import('@/views/BoletoGeradoView.vue'),
    },
    // Rotas para Pessoa Física (PF)
    {
      path: '/pf/home',
      name: 'pf-home',
      component: () => import('@/views/pf/CidadaoView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/dados-conta',
      name: 'pf-dados-conta',
      component: () => import('@/views/pf/DadosContaPFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/dados-conta-escolha',
      name: 'pf-dados-conta-escolha',
      component: () => import('@/views/pf/DadosContaEscolhaPFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/dados-conta-resumo',
      name: 'pf-dados-conta-resumo',
      component: () => import('@/views/pf/DadosContaResumoPFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/dados-conta-pix',
      name: 'pf-dados-conta-pix',
      component: () => import('@/views/pf/DadosContaPixPFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/extrato',
      name: 'pf-extrato',
      component: () => import('@/views/pf/ExtratoPFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/adicionar-dinheiro',
      name: 'pf-adicionar-dinheiro',
      component: () => import('@/views/pf/AdicionarDinheiroPFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/sacar-dinheiro',
      name: 'pf-sacar-dinheiro',
      component: () => import('@/views/pf/SacarDinheiroPFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/confirmar-saque',
      name: 'pf-confirmar-saque',
      component: () => import('@/views/pf/ConfirmarSaquePFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/saque-sucesso',
      name: 'pf-saque-sucesso',
      component: () => import('@/views/pf/SaqueSucessoPFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/depositar-pix',
      name: 'pf-depositar-pix',
      component: () => import('@/views/pf/DepositarPixPFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/confirmar-deposito-pix',
      name: 'pf-confirmar-deposito-pix',
      component: () => import('@/views/pf/ConfirmarDepositoPixPFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/deposito-pix-qrcode',
      name: 'pf-deposito-pix-qrcode',
      component: () => import('@/views/pf/DepositoPixQRCodePFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: '/pf/depositar-boleto',
      name: 'pf-depositar-boleto',
      component: () => import('@/views/pf/DepositarBoletoPFView.vue'),
      meta: { requiresPF: true }
    },
    {
      path: "/:pathMatch(.*)*",
      name: 'NotFound',
      component: () => import('@/views/NotFoundView.vue'),
    },
    ...adminRoutes,
  ],
});

router.beforeEach(async (to) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    '/bootstrap',
    '/sem-acesso',
    '/idrc',
    '/idrc-sucesso',
    '/login',
    '/sem-permissao',
  ];
  const authRequired = !publicPages.includes(to.path);
  const auth = useAuthStore();
  const cartorioStore = useCartorioStore();
  const { logout } = to.query;
  const userSession = Cookies.get('has_user_session')
    ? JSON.parse(atob(Cookies.get('has_user_session'))).message
    : null;

  // 1. Tratar logout primeiro
  if (logout) {
    await auth.logoutCallback();
    return '/';
  }

  // 2. Se é página pública, permitir acesso direto
  if (!authRequired) {
    return;
  }

  // 3. VERIFICAR AUTENTICAÇÃO ANTES DE QUALQUER OUTRA COISA
  // Verificar se tem token ou se precisa de autenticação
  if (auth.token || authRequired) {
    const authenticated = await auth.verifyLogin();

    // Se não está autenticado e a rota requer autenticação, redirecionar para login
    if (!authenticated && authRequired) {
      auth.logoutCallback();
      return '/login';
    }

    // Se está autenticado e está tentando acessar /login, redirecionar para /
    if (authenticated && to.path === '/login') {
      return '/';
    }

    // 4. Carregar dados do usuário APÓS confirmar autenticação
    try {
      auth.user = await authService.getSelfData();
    } catch (error) {
      // Se falhar ao carregar dados, fazer logout e redirecionar para login
      auth.logoutCallback();
      return '/login';
    }
  } else {
    // Se não tem token e não está em página pública, iniciar processo de login
    Cookies.remove('has_user_session');
    if (!(userSession === false) && to.path !== '/login') {
      await auth.login('substancial', 'none');
    }
    return;
  }

  // 5. Carregar cartório do storage se necessário (após autenticação)
  if (!cartorioStore.cartorioAtual) {
    cartorioStore.carregarCartorioDoStorage();
  }

  // 6. VERIFICAR PERMISSÕES (após autenticação confirmada e dados carregados)
  if (to.path !== '/sem-permissao') {
    // Usar o composable para detectar tipo de usuário
    const { isPF, isCartorio, rotaInicial, semPermissao } = useTipoUsuario();
    
    // Se não tem permissão (nem PF nem cartório)
    if (semPermissao.value) {
      sessionStorage.setItem('semPermissaoToast', '1');
      return '/sem-permissao';
    }
    
    // Se é PF tentando acessar rota de cartório, redirecionar para PF
    if (isPF.value && !to.meta?.requiresPF && to.path !== '/pf/home') {
      // Permitir acesso à rota inicial de cartório apenas para redirecionamento
      if (to.path === '/') {
        return rotaInicial.value;
      }
      // Para outras rotas de cartório, redirecionar para home PF
      return '/pf/home';
    }
    
    // Se usuário está na rota inicial (/) mas é PF (sem cartório), redirecionar automaticamente
    if (to.path === '/' && isPF.value && !isCartorio.value) {
      return '/pf/home';
    }
    
    // Se é cartório tentando acessar rota de PF, redirecionar para cartório
    if (isCartorio.value && to.meta?.requiresPF) {
      return '/';
    }
    
    // Verificar permissão específica para cartório
    if (isCartorio.value) {
      const funcao = cartorioStore.funcaoCartorio;
      if (!cartorioStore.verificarPermissaoFuncao(funcao)) {
        sessionStorage.setItem('semPermissaoToast', '1');
        return '/sem-permissao';
      }
    }
    
    sessionStorage.removeItem('semPermissaoToast');
  }
});

export default router;
